import { FC } from "react";
import { useNavigate } from "react-router";
import { Box, Flex, Heading, Text } from "@radix-ui/themes";

import { atlasRoutes } from "@/app/router/routes";
import { Button } from "@/components/button";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";

export const DataExportsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <Box p="4" style={{ maxWidth: 720 }}>
      <Heading size="7" mb="4">
        Data Exports
      </Heading>

      <Text as="p" size="3" mb="4" color="gray">
        Inspect, create, and re-run exports for troubleshooting user issues.
      </Text>

      <Flex gap="3" mb="5" wrap="wrap">
        <Button size="2" onClick={() => navigate(atlasRoutes.dataExportsCreate({}).path)}>
          Create Export
        </Button>
      </Flex>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.dataExportsView({ params: { dataExportId: uuid } }).path)
        }
        placeholder="9c15f07c-7ef4-4e65-82f0-5abf0aab8fbe"
        buttonLabel="View Export"
      />
    </Box>
  );
};
